// extracted by mini-css-extract-plugin
module.exports = {"bundles":"Bundle_bundles__X8iTh"};